import React from 'react';
import { Select } from '@gerdau/hefesto/Select';
import moment from 'moment';
import { EUploadProjectOption } from '../..';
import { IFabricationProject } from '../../../../../../../store/ducks/fabrication-projects/types';
import { ProjectWithMockupSpan } from './styles';

interface IFabricationProjectSelectProps {
  title?: string;
  placeholder?: string;
  projects: IFabricationProject[];
  selectedProject?: IFabricationProject;
  onSelectProject(projectId: number): void;
  uploadProjectOption?: EUploadProjectOption;
  loading: boolean;
}

const FabricationProjectSelect: React.FC<IFabricationProjectSelectProps> = ({
  placeholder,
  projects,
  selectedProject,
  onSelectProject,
  uploadProjectOption,
  loading
}) => {
  const getProjects = () => {
    return projects.map(
      ({
        id,
        fileName,
        structures,
        revisionStatus,
        creationDate,
        mockupName
      }) => {
        const projectStructures = structures.map((ps) => ps.name);
        return {
          label: fileName,
          value: id.toString(),
          descriptions: [
            `Maquete: ${mockupName || '-'}`,
            `Estrutura: ${projectStructures.join(', ')}`,
            `${revisionStatus} Enviado ${moment(
              creationDate,
              'YYYY-MM-DD'
            ).format('DD/MM/YYYY')}`
          ]
        };
      }
    );
  };

  return (
    <>
      {(!selectedProject ||
        uploadProjectOption === EUploadProjectOption.MOCKUP_PROJECT) && (
        <Select
          label={''}
          name={'projectSelect'}
          hideLabel
          placeholder={placeholder}
          options={getProjects()}
          value={
            selectedProject && !loading
              ? selectedProject.id.toString()
              : undefined
          }
          onSelect={(value) => {
            onSelectProject(Number(value));
          }}
          disabled={
            loading || uploadProjectOption === EUploadProjectOption.FREE_PROJECT
          }
        />
      )}

      {!!selectedProject &&
        uploadProjectOption === EUploadProjectOption.FREE_PROJECT && (
          <ProjectWithMockupSpan title={selectedProject?.fileName}>
            {selectedProject?.fileName}
          </ProjectWithMockupSpan>
        )}
    </>
  );
};

export default FabricationProjectSelect;
